import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import i18next from "i18next";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import AuthProvider from "@mnjsplatform/data/lib/security/authProvider";
import pathJoin from "@mnjsplatform/data/lib/utils/pathJoin";
import $ from "jquery";
import Signature from "./Signature";
import {formatMnDate} from "@mnjsplatform/data/lib/utils/formatData";
import MessageBox from "@mnjsplatform/components/lib/common/MessageBox";
import DoAsk from "./DoAsk";
import YourPhoneNumber from "./YourPhoneNumber";

class EDDocList extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            signComment: null,
            showSignComment: false,
            showDoAsk: false,
            rowKey: null,
            persInfo: null
        };
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        try {
            await this.props.dispatch(this.props.EDoc_ListForPO.execute({}, {withParams: true}));
            await this.props.dispatch(this.props.EDocPers_Get.execute());
            this.setState({persInfo: this.props.EDocPers_Get.getRow(0)});
        } catch (e) {
            console.error(e);
        }
    }

    refresh = async () => {
        await this.props.dispatch(this.props.EDoc_ListForPO.refresh());
    }

    signDocument = async (row, event) => {
        event.preventDefault();
        await this.props.dispatch(this.props.EDoc_SignForPO.execute({EDocIntId: row.EDocIntId}));
        //
        if (!this.props.EDoc_SignForPO.isError) {
            this.setState({
                signComment: i18next.t("ED_Doc_List_1", {
                    numberDoc: row.NumberDoc,
                    dateDoc: formatMnDate(row.DateDoc),
                    date: (new Date()).toLocaleDateString()
                }),
                showSignComment: true
            });
        }
    }

    getDocument = async (row, event) => {
        event.preventDefault();
        const token = await AuthProvider.getToken();
        const downloadPath = pathJoin(window.config.apiRoot, "EDDocList", "DownloadDocument") + "?" + $.param({
            b_token: token,
            id: row.EDocIntId
        });
        window.open(downloadPath, '_blank');
    }

    doAsk = (row, event) => {
        event && event.preventDefault();

        const rowKey = this.props.EDoc_ListForPO.getRowKey(row);
        this.setState({showDoAsk: true, rowKey: rowKey});
    }

    renderCellEx = (cellParams) => {
        if (cellParams.fieldInfo.Name === "IsSignedMsg" && cellParams.row['IsSigned'] === 0) {
            return (
                <div>
                    <label>
                        <a href="" rel="noopener noreferrer"
                           onClick={(event) => this.signDocument(cellParams.row, event)}
                           className="mr-2">{cellParams.row[cellParams.fieldInfo.Name]}</a>
                    </label>
                </div>);
        } else if (cellParams.fieldInfo.Name === "DoDownload") {
            return (
                <div>
                    <label>
                        <a href="" rel="noopener noreferrer"
                           onClick={(event) => this.getDocument(cellParams.row, event)}
                           className="mr-2">{cellParams.row.DoDownload}</a>
                    </label>
                </div>);
        } else if (cellParams.fieldInfo.Name === "DoAsk") {
            return (
                <div>
                    <label>
                        <a href="" rel="noopener noreferrer"
                           onClick={(event) => this.doAsk(cellParams.row, event)}
                           className="mr-2">{cellParams.row.DoAsk}</a>
                    </label>
                </div>);
        }
        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    }

    paramRender = (h) => {
        return (<>
            <div className="row mb-2">
                <div className="col-md-2 text-right">
                    {h.lbl("DateBegin")}
                </div>
                <div className="col-md-4">
                    {h.ed("DateBegin")}
                </div>
                <div className="col-md-2 text-right">
                    {h.lbl("DateEnd")}
                </div>
                <div className="col-md-4">
                    {h.ed("DateEnd")}
                </div>
            </div>

            <div className="row">
                <div className="col-md-2 text-right">
                    {h.lbl("EDocTypeName")}
                </div>
                <div className="col-md-4">
                    {h.ed("EDocTypeName")}
                </div>
                <div className="col-md-2 text-right">
                    {h.lbl("IsSigned")}
                </div>
                <div className="col-md-4">
                    {h.ed("IsSigned")}
                </div>
            </div>
        </>);
    };

    render() {

        return (
            <>
                <MessageBox visible={this.state.showSignComment}
                            title={i18next.t('signComment')}
                            messageText={this.state.signComment}
                            onClose={() => {
                                this.setState({showSignComment: false}, () => this.refresh());
                            }}
                />
                {this.state.persInfo && (this.state.persInfo.IsEdocPers === 0 || this.state.persInfo.IsSign === 0) &&
                    <Signature message={this.state.persInfo["Mess"]}
                               isCreateButton={this.state.persInfo["IsCreateButton"]} onRefresh={async () => {
                        await this.props.dispatch(this.props.EDocPers_Get.refresh());
                        this.setState({persInfo: this.props.EDocPers_Get.getRow(0)});
                    }}/>}
                {
                    this.state.showDoAsk &&
                    <DoAsk rowKey={this.state.rowKey} dispatch={this.props.dispatch}
                           dataItem={this.props.dataItem_SaveAsk}
                           dataItem_Params={this.props.dataItem_SaveAsk_Params}
                           onClose={() => {
                               this.setState({showDoAsk: false})
                           }}/>
                }
                <PlaceholderWrapper placeholderId="30"
                                    title={<><i className='fa fa-list'/> {i18next.t("EDDocList")}</>}
                                    showSplitterLine={true} canCollapse={false}>
                    <ComplexParam parentDataItem={this.props.EDoc_ListForPO}
                                  dataItem={this.props.EDoc_ListForPO_Params}
                                  renderParams={this.paramRender}
                                  showApplyButton={false} autoApplyParams={true}
                                  readOnly={false} showSearchBar={false}
                                  rootPath="/"/>
                    <span>&nbsp;</span>
                    <GridView dataItem={this.props.EDoc_ListForPO} renderCellEx={this.renderCellEx}/>
                </PlaceholderWrapper>
                {this.state.persInfo && <YourPhoneNumber phone={this.state.persInfo["PhoneNumber"]}/>}
            </>
        )
    }
}

EDDocList.propTypes = {
    dispatch: PropTypes.func.isRequired,
    EDoc_ListForPO: PropTypes.object,
    EDoc_ListForPO_Params: PropTypes.object,
    EDoc_SignForPO: PropTypes.object,
    EDoc_GetDoc: PropTypes.object,
    dataItem_SaveAsk: PropTypes.object,
    dataItem_SaveAsk_Params: PropTypes.object,
    EDocPers_Get: PropTypes.object,
    workplaceType: PropTypes.string
}

EDDocList.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        EDoc_ListForPO: state.docflowState.EDoc_ListForPO,
        EDoc_ListForPO_Params: state.docflowState.EDoc_ListForPO_Params,
        EDoc_SignForPO: state.docflowState.EDoc_SignForPO,
        EDoc_GetDoc: state.docflowState.EDoc_GetDoc,
        dataItem_SaveAsk: state.docflowState.EDocAsk_Save,
        dataItem_SaveAsk_Params: state.docflowState.EDocAsk_Save_Params,
        EDocPers_Get: state.docflowState.EDocPers_Get,
        workplaceType: state.appState.appParams.workplaceType
    }
}

export default connect(mapStateToProps)(EDDocList)